<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:headerTitle>
              <h4 class="card-title">{{ $t('event_manage.event_summary_report') }}</h4>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" >
                    <b-row>
                        <b-col lg="6" md="6" sm="12" rules= "required">
                            <ValidationProvider name="Year" vid="year">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="year"
                                >
                                <template v-slot:label>
                                    {{ $t('event_manage.year')}} <span class="">*</span>
                                </template>
                                <b-form-select
                                    plain
                                    v-model="search.year"
                                    :options="yearList"
                                    id="circular_type"
                                >
                                    <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                            </ValidationProvider>
                        </b-col>
                       <b-col lg="6" md="6" sm="12">
                            <ValidationProvider name="Event Type" vid="event_type_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="event_type_id"
                                >
                                <template v-slot:label>
                                    {{ $t('awareness_config.event_type')}}
                                </template>
                                <b-form-select
                                    plain
                                    v-model="search.event_type_id"
                                    :options="eventTypeList"
                                    id="event_type_id"
                                >
                                    <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                                <ValidationProvider name="Event Name" vid="event_name_id">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="event_name_id"
                                    >
                                    <template v-slot:label>
                                        {{ $t('awareness_config.event_name')}}
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="search.event_name_id"
                                        :options="eventList"
                                        id="event_name_id"
                                    >
                                        <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                                </ValidationProvider>
                        </b-col>
                      <b-col lg="6" md="6" sm="12">
                          <div class="col-sm-4"></div>
                            <div class="col text-left">
                                <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.search') }}</b-button>
                            </div>
                      </b-col>
                    </b-row>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
        <b-row >
          <b-col md="12" v-if="showData">
              <iq-card>
                <template v-slot:body>
                  <b-row>
                    <b-col md="12">
                      <iq-card>
                        <template v-slot:headerTitle>
                          <h4 class="card-title">{{ $t('event_manage.event_summary_report_list') }}</h4>
                        </template>
                        <template v-slot:headerAction>
                          <b-button variant="primary" @click="pdfExport" class="mr-2">
                            {{  $t('globalTrans.export_pdf') }}
                          </b-button>
                          <export-excel
                            class="btn btn-success mr-2"
                            :data="excelData"
                            :title="headerValue"
                            worksheet="Report Sheet"
                            :default-value="headerExcelDefault"
                            name="event_summary_report.xls">
                            {{ $t('globalTrans.export_excel') }}
                          </export-excel>
                        </template>
                        <template v-slot:body>
                         <b-overlay :show="loader">
                            <b-row mt-5>
                              <b-col md="12" class="table-responsive">
                                <div style="border: 2px solid;margin:10px;padding:10px">
                                  <b-row>
                                    <b-col>
                                      <list-report-head :base-url="awarenessEventServiceBaseUrl" :uri="reportHeadingList" :org-id="3">
                                        {{ $t('event_manage.event_summary_report') }}
                                      </list-report-head>
                                    </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col xs="12" sm="12" md="6" class="text-left">
                                      <table style="color:black;">
                                          <tr v-if="search.year">
                                            <td align="right">{{ $t('event_manage.year') }}</td>
                                            <td align="center">:</td>
                                            <td align="left">{{ ($i18n.locale==='bn') ? search.year_bn : search.year }}</td>
                                          </tr>
                                          <tr v-if="search.event_name">
                                            <td align="right">{{ $t('awareness_config.event_name') }}</td>
                                            <td align="center">:</td>
                                            <td align="left">{{ ($i18n.locale==='bn') ? search.event_name_bn : search.event_name }}</td>
                                          </tr>
                                      </table>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="6" class="text-right">
                                      <table style="color:black; float:right;margin-right:0px;">
                                          <tr v-if="search.event_type_name">
                                            <td align="right">{{ $t('awareness_config.event_type') }}</td>
                                            <td align="center">:</td>
                                            <td align="left">{{ ($i18n.locale==='bn') ? search.event_type_name_bn : search.event_type_name }}</td>
                                          </tr>
                                      </table>
                                    </b-col>
                                  </b-row>
                                  <b-row>
                                      <b-col>
                                        <b-table-simple class="tg mt-3" bordered hover small caption-top responsive>
                                          <b-thead>
                                            <b-tr>
                                              <b-th style="width:10%" class="text-center">{{ $t('globalTrans.sl_no') }}</b-th>
                                              <b-th style="width:10%" class="text-center">{{ $t('event_manage.org_name') }}</b-th>
                                              <b-th style="width:10%" class="text-center">{{ $t('event_manage.address') }}</b-th>
                                              <b-th style="width:10%" class="text-center">{{ $t('event_manage.contact_person_name') }}</b-th>
                                              <b-th style="width:10%" class="text-center">{{ $t('event_manage.contact_no') }}</b-th>
                                              <b-th style="width:10%" class="text-center">{{ $t('event_manage.amount') }}</b-th>
                                            </b-tr>
                                          </b-thead>
                                          <b-tbody  v-for="(info, index) in datas" :key="index" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                                            <b-td class="text-center">{{ $n(index + 1) }}</b-td>
                                            <b-td class="text-center">{{ ($i18n.locale === 'bn') ? info.org_name_bn : info.org_name }}</b-td>
                                            <b-td class="text-center">{{ ($i18n.locale === 'bn') ? info.address_bn : info.address }}</b-td>
                                            <b-td class="text-center">{{ ($i18n.locale === 'bn') ? info.contact_person_name_bn : info.contact_person_name }}</b-td>
                                            <b-td class="text-center">{{ ($i18n.locale === 'bn') ? '০' : '0' }}{{ $n(info.contact_no, { useGrouping: false }) }}</b-td>
                                            <b-td class="text-center">{{ $n(info.total_cost, { useGrouping: false }) }}</b-td>
                                          </b-tbody>
                                        </b-table-simple>
                                      </b-col>
                                  </b-row>
                                </div>
                              </b-col>
                            </b-row>
                          </b-overlay>
                        </template>
                      </iq-card>
                    </b-col>
                  </b-row>
                </template>
              </iq-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { stallPanelEventSummaryReport, reportHeadingList } from '../../api/routes'
import flatpickr from 'flatpickr'
import ListReportHead from '@/components/custom/ListReportHeadAwareness.vue'
import ExportPdf from './export-pdf_details'
import excel from 'vue-excel-export'
import Vue from 'vue'
import { helpers } from '@/mixins/helper-functions'
Vue.use(excel)

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider,
        ListReportHead
    },
    data () {
        return {
          search: {
            year: new Date().getFullYear(),
            event_type_id: 0,
            event_name_id: 0
          },
          awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl,
          reportHeadingList: reportHeadingList,
          datas: [],
          headerExcelDefault: {
            orgName: null,
            orgNameBn: null,
            address: null,
            address_bn: null
          },
          loading: false,
          showData: false,
          eventList: [],
          loader: false
        }
    },
    mounted () {
      core.index()
      flatpickr('.datepicker', {})
      this.headerDataExcel()
    },
    watch: {
        'search.event_type_id': function (newVal) {
            this.eventList = this.getEventList(newVal)
        }
    },
    computed: {
        headerValue: function () {
            const headerVal = []
            if (this.$i18n.locale === 'en') {
              headerVal[0] = this.headerExcelDefault.orgName
              headerVal[1] = this.headerExcelDefault.address
              headerVal[2] = this.$t('event_manage.event_summary_report')
              headerVal[3] = this.getHeadParam()
              headerVal[4] = ''
            } else {
              headerVal[0] = this.headerExcelDefault.orgNameBn
              headerVal[1] = this.headerExcelDefault.address_bn
              headerVal[2] = this.$t('event_manage.event_summary_report')
              headerVal[3] = this.getHeadParam()
              headerVal[4] = ''
            }
            return headerVal
        },
        excelData: function () {
            const listData = this.datas
            var serial = 0
            const listContractor = listData.map(keyItem => {
            serial++
                if (this.$i18n.locale === 'en') {
                  return {
                    'sl ': serial,
                    'Organization Name': keyItem.org_name,
                    'Address ': keyItem.address_bn,
                    'Contact Person Name': keyItem.contact_person_name,
                    'Contact No': keyItem.contact_no,
                    'Amount ': keyItem.total_cost
                  }
                } else {
                  return {
                    'ক্রমিক সংখ্যা': this.$n(serial),
                    'প্রতিষ্ঠানের নাম ': keyItem.org_name_bn,
                    'ঠিকানা ': keyItem.address,
                    'যোগাযোগ ব্যক্তির নাম': keyItem.contact_person_name_bn,
                    'যোগাযোগের নম্বর': this.$n(keyItem.contact_no),
                    'পরিমাণ ': this.$n(keyItem.total_cost)
                  }
                }
            })
            return listContractor
        },
        yearList () {
            return helpers.getYearList()
        },
        eventTypeList: function () {
            return this.$store.state.ExternalUser.stallParticipantCommonObj.eventTypeList.filter(item => item.status === 1)
        }
    },
    methods: {
        headerDataExcel () {
            RestApi.getData(awarenessEventServiceBaseUrl, '/configuration/report-heading/detail/3').then(response => {
              if (response.success) {
                const orgList = this.$store.state.commonObj.organizationProfileList.find(item => item.value === 13)
                const orgName = typeof orgList !== 'undefined' ? orgList.text_en : ''
                const orgNameBn = typeof orgList !== 'undefined' ? orgList.text_bn : ''
                this.headerExcelDefault.orgName = orgName
                this.headerExcelDefault.orgNameBn = orgNameBn
                this.headerExcelDefault.address = response.data.address
                this.headerExcelDefault.address_bn = response.data.address_bn
              }
            })
        },
        pdfExport () {
            const reportTitle = this.$t('event_manage.event_summary_report')
            ExportPdf.exportPdfDetails(awarenessEventServiceBaseUrl, '/configuration/report-heading/detail', 3, reportTitle, this.datas, this, this.search)
        },
        async searchData () {
          this.getCustomSearch()
          this.loader = true
          this.showData = true
          const params = Object.assign({}, this.search)
            const result = await RestApi.getData(awarenessEventServiceBaseUrl, stallPanelEventSummaryReport, params)
                if (result.success) {
                  this.datas = result.data
                } else {
                  this.datas = []
                }
            this.loader = false
        },
        getEventList (id) {
           return this.$store.state.ExternalUser.stallParticipantCommonObj.eventList.filter(item => item.status === 1 && item.event_type_id === id)
        },
        getCustomSearch () {
          const yearObj = this.yearList.find(year => year.value === this.search.year)
            if (typeof yearObj !== 'undefined') {
              this.search.year = yearObj.text
              this.search.year_bn = yearObj.text
            } else {
              this.search.year = ''
              this.search.year_bn = ''
            }
          const eventTypeObj = this.$store.state.AwarenessEventService.commonObj.eventTypeList.find(eventTypeList => eventTypeList.value === parseInt(this.search.event_type_id))
            if (typeof eventTypeObj !== 'undefined') {
              this.search.event_type_name = eventTypeObj.text_en
              this.search.event_type_name_bn = eventTypeObj.text_bn
            } else {
              this.search.event_type_name = ''
              this.search.event_type_name_bn = ''
            }
          const eventNameObj = this.$store.state.AwarenessEventService.commonObj.eventList.find(eventList => eventList.value === parseInt(this.search.event_name_id))
            if (typeof eventNameObj !== 'undefined') {
               this.search.event_name = eventNameObj.text_en
               this.search.event_name_bn = eventNameObj.text_bn
            } else {
              this.search.event_name = ''
              this.search.event_name_bn = ''
            }
        },
        getHeadParam () {
          let tmpText = `${this.$t('event_manage.year')} : ${(this.$i18n.locale === 'en' ? this.search.year : this.search.year_bn) ? (this.$i18n.locale === 'en' ? this.search.year : this.search.year_bn) : this.$t('globalTrans.all')}`
          tmpText += `, ${this.$t('awareness_config.event_name')} : ${(this.$i18n.locale === 'en' ? this.search.event_name : this.search.event_name_bn) ? (this.$i18n.locale === 'en' ? this.search.event_name : this.search.event_name_bn) : this.$t('globalTrans.all')}`
          tmpText += `, ${this.$t('awareness_config.event_type')} : ${(this.$i18n.locale === 'en' ? this.search.event_type_name : this.search.event_type_name_bn) ? (this.$i18n.locale === 'en' ? this.search.event_type_name : this.search.event_type_name_bn) : this.$t('globalTrans.all')}`
          return tmpText
        }
    }
}
</script>
